module.exports = __webpack_public_path__ + "static/img/6.360da4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/6.png
// module id = yaRg
// module chunks = 4